// "Production" enabled environment
import {VERSION} from './version';
export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.stage.json',
    version: VERSION.version,
    remoteServiceBaseUrl: 'https://praxisankerapi.reacsys.de',
};

console.log('stage: ' + VERSION.version);
